import { BLACK_d, MAIN_GREEN } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Container = styled.div`
  margin-top: 19.5rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  margin-bottom: 34.5rem;
  & > span {
    font-weight: 700;
    font-size: 4rem;
    line-height: 7rem;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 15rem;
    margin-bottom: 25rem;
    & > span {
      font-weight: 700;
      font-size: 3.2rem;
      line-height: 5.4rem;
    }
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  border: 1px solid #363636;
  border-radius: 0.5rem;
  overflow: hidden;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 100vw;
    margin-left: -20px;
    border-radius: 0rem;
  }
`;

export const TopBox = styled.div`
  display: flex;
  gap: 3rem;
  padding: 2.5rem 2.8rem;
  font-weight: 700;
  font-size: 2.2rem;
  line-height: 3.8rem;
  border-bottom: 1px solid #363636;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    padding: 1.5rem 2rem;
    gap: 2rem;
    font-size: 1.8rem;
    line-height: 3.2rem;
    overflow-x: auto;
    & > span {
      padding: 0.5rem 1.5rem;
    }
  }
`;
export const TopNav = styled.div`
  background-color: ${(props) => (props.isSelected ? MAIN_GREEN : "none")};
  color: ${(props) => (props.isSelected ? "black" : "white")};
  padding: 0.5rem 2rem;
  border-radius: 0.5rem;
  cursor: pointer;
  &:hover {
    color: ${(props) => (props.isSelected ? "black" : "#21f650")};
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    padding: 0.5rem 1.5rem;
  }
`;

export const BottomBox = styled.div`
  width: 100%;
  height: 23.7rem;
  display: flex;
  justify-content: space-between;
  padding: ${(props) => (props.language === "en" ? "5rem 2rem 5rem 7.8rem" : "5rem 7.8rem")};
  background: #0e0e0e;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    flex-direction: column;
    gap: 6rem;
    padding: 5rem 20px;
    height: auto;
  }
`;

export const BottomTextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  & > span {
    font-weight: 700;
    font-size: 1.6rem;
    line-height: 2.8rem;
  }
`;

export const BottomList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  & > div {
    display: flex;
    gap: 0.8rem;
    & > img {
      margin-top: 1.3rem;
      width: 0.2rem;
      height: 0.2rem;
    }
    & > span {
      font-weight: 300;
      font-size: 1.6rem;
      line-height: 2.8rem;
      color: ${BLACK_d};
      white-space: nowrap;
    }
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    & > div {
      & > span {
        display: flex;
        flex-direction: column;
        white-space: normal;
      }
    }
  }
`;
